var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.794 11.3419V7.05037C11.794 6.7518 11.7377 6.45636 11.6284 6.18216C11.5191 5.90797 11.3592 5.66077 11.1584 5.45573L7.41874 1.63474C7.23039 1.44223 6.98102 1.33496 6.72182 1.33496C6.46262 1.33496 6.21326 1.44223 6.02491 1.63474L2.2852 5.45573C2.08446 5.66077 1.92455 5.90797 1.81526 6.18216C1.70598 6.45636 1.64963 6.7518 1.64966 7.05037V11.3419C1.64966 11.6327 1.75654 11.9117 1.94678 12.1174C2.13702 12.323 2.39505 12.4386 2.66409 12.4386H10.7796C11.0486 12.4386 11.3066 12.323 11.4969 12.1174C11.6871 11.9117 11.794 11.6327 11.794 11.3419Z",
    fill: "#87888C",
    stroke: "#87888C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b0ccd9aae05b9ec1df1ab4ec63aa96a0.svg";
export { ForwardRef as ReactComponent };